import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';

import { Chip } from '@shared/components/chip/chip.component';

@NgModule({
  declarations: [Chip],
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTooltipModule],
  exports: [Chip],
})
export class ChipModule {}
